import React from 'react';
import { Dumbbell, Target, TrendingUp } from 'lucide-react';

const cards = {
  en: [
    {
      icon: Dumbbell,
      title: 'Anywhere & Anytime',
      desc: 'Train at home, in the park or at the gym.',
    },
    {
      icon: Target,
      title: 'Gentle & Effective',
      desc: 'Adapted to your energy level and daily life.',
    },
    {
      icon: TrendingUp,
      title: 'Lasting Results',
      desc: 'No yo-yo effect — real change from within.',
    },
  ],
  de: [
    {
      icon: Dumbbell,
      title: 'Überall & Jederzeit',
      desc: 'Trainiere zuhause, im Park oder im Fitnessstudio.',
    },
    {
      icon: Target,
      title: 'Sanft & Effektiv',
      desc: 'Angepasst an dein Energieniveau und deinen Alltag.',
    },
    {
      icon: TrendingUp,
      title: 'Nachhaltige Ergebnisse',
      desc: 'Kein Jojo-Effekt — echte Veränderung von innen heraus.',
    },
  ],
};

export default function Benefits({ lang }) {
  const t = {
    headline: lang === 'de' ? 'DEINE VORTEILE MIT FITXCELERATE' : 'YOUR BENEFITS WITH FITXCELERATE',
    sub:
      lang === 'de'
        ? 'FitXcelerate bietet dir alles, was du für dauerhaften Erfolg brauchst.'
        : 'FitXcelerate gives you everything you need for lasting results.',
  };

  return (
    <section className="bg-white py-20 lg:py-28">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 bg-emerald-100 text-emerald-700 text-xs font-bold uppercase tracking-widest rounded-full mb-4">
            {lang === 'de' ? 'Vorteile' : 'Benefits'}
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-slate-900 tracking-tight">
            {t.headline}
          </h2>
          <p className="mt-4 text-lg text-slate-500 max-w-xl mx-auto">{t.sub}</p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {cards[lang].map(({ icon: Icon, title, desc }, i) => (
            <div
              key={i}
              className="group flex flex-col items-start gap-5 bg-white rounded-2xl p-7 border border-slate-200 shadow-sm hover:shadow-xl hover:border-emerald-200 hover:scale-[1.02] transition-all duration-300 cursor-default"
            >
              {/* Icon circle */}
              <div className="w-14 h-14 rounded-2xl bg-emerald-600 group-hover:bg-emerald-700 flex items-center justify-center shadow-md transition-colors duration-300">
                <Icon size={26} color="white" strokeWidth={2} />
              </div>

              {/* Text */}
              <div>
                <h3 className="text-xl font-bold text-slate-900 mb-2">{title}</h3>
                <p className="text-slate-500 leading-relaxed">{desc}</p>
              </div>

              {/* Arrow hint */}
              <div className="mt-auto pt-2">
                <span className="text-xs font-semibold text-emerald-600 uppercase tracking-widest opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  {lang === 'de' ? 'Mehr erfahren →' : 'Learn more →'}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
